import { Send, PenTool, Download, Upload } from "lucide-react";
import { Chapter, Reveal } from "./Shared";

const STEPS = [
  {
    test: "how-it-works-step-1",
    num: "01",
    icon: Send,
    title: "Tell us what you want.",
    example: "Funny Halloween teacher design. Retro. Leopard print. Comfort Colors.",
  },
  {
    test: "how-it-works-step-2",
    num: "02",
    icon: PenTool,
    title: "Our designer creates it.",
    sub: "Original artwork built around your brief by a human designer.",
  },
  {
    test: "how-it-works-step-3",
    num: "03",
    icon: Download,
    title: "You receive it.",
    sub: "300 DPI PNG, transparent background, production-ready.",
  },
  {
    test: "how-it-works-step-4",
    num: "04",
    icon: Upload,
    title: "Upload to Etsy.",
    sub: "Done.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="relative">
      <div className="mx-auto max-w-6xl px-6 py-16 sm:py-20">
        <Reveal className="text-center">
          <Chapter num="02" label="The Process" className="justify-center" />
          <h2 className="mt-6 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Brief → Design → Download
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.test} delay={i * 0.08} className="h-full">
              <div
                data-testid={s.test}
                className="relative flex h-full flex-col rounded-3xl border border-white/10 bg-[#0C1222]/80 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-amber-400/40 hover:shadow-[0_16px_44px_rgba(245,158,11,0.14)]"
              >
                <div className="flex items-center justify-between">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl border border-amber-400/30 bg-amber-400/10">
                    <s.icon className="h-5 w-5 text-amber-300" />
                  </span>
                  <span className="font-mono text-2xl font-extrabold text-white/15">{s.num}</span>
                </div>
                <h3 className="mt-5 text-base font-bold leading-snug text-white">{s.title}</h3>

                {s.example ? (
                  <div
                    data-testid="how-it-works-example-brief"
                    className="mt-4 rounded-xl border border-amber-400/25 bg-amber-400/5 px-4 py-3 text-[13px] italic leading-snug text-amber-200/90"
                  >
                    "{s.example}"
                  </div>
                ) : (
                  <p className="mt-3 text-[13px] leading-relaxed text-slate-400">{s.sub}</p>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}